import { isArray, mergeWith } from 'lodash'

const customMerge = (object: unknown, source: unknown): unknown => {
  if (isArray(object) && isArray(source)) {
    return source
  }
}

export const mergeObjects = (object: unknown, source: unknown): unknown => {
  return mergeWith(object, source, customMerge)
}

export const copyNestedObjects = (
  source: unknown[] | unknown | null,
  fieldsToKeep: string[] | null = null
): unknown[] | object | null | undefined => {
  if (source === null) {
    return null
  }
  if (Array.isArray(source)) {
    const target: object[] | null[] | undefined[] = Array.from(source)
    for (let i = 0; i < target.length; i++) {
      target[i] = copyNestedObjects(target[i])
    }
    return target
  }
  if (typeof source === 'object') {
    const target: { [key: string]: unknown } = Object.assign({}, source) as { [key: string]: unknown }
    Object.keys(source).forEach((e) => {
      if (fieldsToKeep) {
        if (!fieldsToKeep.includes(e)) {
          delete target[e]
        } else {
          target[e] = copyNestedObjects(target[e])
        }
      } else {
        target[e] = copyNestedObjects(target[e])
      }
    })
    return target
  }
  return source
}

export const getId = <T extends { id: unknown }>(item: T): T['id'] => item.id

export const getObjectById = <T extends object>(array: T[], objectId: number | string): T | undefined => {
  return array.find((object) => ('id' in object ? object.id === objectId : false))
}
